import { useFormikContext } from 'formik';
import React from 'react';

import AutocompleteField from '@components/Form/AutocompleteField';
import DropdownField from '@components/Form/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_JOB_FUNCTION,
  ENTITY_WORD_TYPE_COMMON,
  JOB_FUNCTION_OPTIONS,
  PROFILE_FIELD_OTHER_VALUE,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';

interface JobFunctionFieldsProps {
  isRequired: boolean;
  silenceToast?: boolean;
}

const JobFunctionFields = ({ isRequired, silenceToast = false }: JobFunctionFieldsProps) => {
  const { values } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate(silenceToast);

  return (
    <>
      <DropdownField
        name="jobFunction"
        options={JOB_FUNCTION_OPTIONS}
        label={isRequired ? 'Job Function*' : 'Job Function'}
        placeholder="Select"
        isClearable={false}
        scrollIntoView
      />
      {values.jobFunction.value === PROFILE_FIELD_OTHER_VALUE && (
        <div className="mt-4">
          <AutocompleteField
            name="customJobFunction"
            fetchMethod={(value) =>
              autocompleteEntities({
                fragment: value,
                entity_type: ENTITY_TYPE_JOB_FUNCTION,
              })
            }
            createMethod={(value) =>
              createEntityAsync({
                name: value,
                entity_type: ENTITY_TYPE_JOB_FUNCTION,
                word_type: ENTITY_WORD_TYPE_COMMON,
              })
            }
          />
        </div>
      )}
    </>
  );
};

export default JobFunctionFields;
